import { css } from "@emotion/react";


export const emotionGlobalCss = css`
.heroImage {
  height: 350px;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: flex-start;
  align-items: center
}

.heroImage .wrap {
  width: 100%;
  text-align: center
}

div#hero .wrap {
  display: flex;
  align-items: center;
  height: 100%
}
.author-box::before, .clearfix::before, .entry::before, .entry-content::before, .footer-widgets::before, .nav-primary::before, .nav-secondary::before, .pagination::before, .site-container::before, .site-footer::before, .site-header::before, .site-inner::before, .widget::before, .wrap::before {
  content: " ";
  display: table
}

.author-box::after, .clearfix::after, .entry::after, .entry-content::after, .footer-widgets::after, .nav-primary::after, .nav-secondary::after, .pagination::after, .site-container::after, .site-footer::after, .site-header::after, .site-inner::after, .widget::after, .wrap::after {
  clear: both;
  content: " ";
  display: table
}
.wrap {
  margin: 0 auto;
  max-width: 1280px
}
.jumpMenu {
  background-color: #70c000
}

.jumpMenu .wrap {
  display: flex
}
.jumpMenu .wrap a {
  flex: 1 1 100%;
  text-align: center;
  padding: 15px 10px;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 900;
  background-color: #70c000
}

.jumpMenu .wrap a:hover, .jumpMenu .wrap a:focus {
  background-color: #fff;
  color: #70c000
}

.jumpMenu .wrap a.links.current {
  color: #70c000;
  background-color: #fff
}
.home .site-inner {
  padding-top: 0
}
.site-inner {
  clear: both;
  padding-top: 0px;
  word-wrap: break-word
}
.greyBack .titleBox {
  max-width: 500px
}
.greyBack {
  background-color: #fafafa;
  padding: 80px 0
}
.titleBox {
  max-width: 800px;
  text-align: center;
  margin: 0 auto 40px
}

.titleBox h2 {
  font-weight: 600;
  font-size: 1.9rem;
}

.titleBox p:last-of-type {
  margin-bottom: 0
}

.titleBox p {
  margin-bottom: 10px;
  color: #98a2a4;
  line-height: 1.2
}
.modelsFlex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between
}

.modelsFlex>div {
  flex: 0 0 32%
}
.eachModel {
  background-color: #fff;
  margin-bottom: 30px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap
}

.eachModel img {
  max-width: 90%;
  max-height: 200px;
  padding: 20px 0;
  flex: 0 0 auto;
  -o-object-fit: contain;
     object-fit: contain
}

.eachModel .modelBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0 20px;
  transition: all .2s ease-in-out;
  flex: 1 1 100%;
  width: 100%
}

.eachModel .modelBox p {
  opacity: 0;
  margin-bottom: 0;
  height: 0;
  line-height: 1.2;
  font-weight: 100;
  font-size: 1.1rem;
  max-width: 250px
}
.eachModel:hover .modelBox p {
  opacity: 1;
  height: auto
}

.eachModel:hover .modelBox {
  background-color: #70c000;
  padding: 20px 0;
  color: #fff
}
.eachModel:hover .modelBox h4 {
  color: #fff
}
.modelBox h4 {
  color: #000;
  font-weight: 600;
  transition: all .2s ease-in-out;
  margin-bottom: 2px;
  font-size: 1.2rem;
}
.benefits {
  background-color: #70c000;
  color: #fff;
  padding: 50px 0;
  margin-bottom: 40px;
}
.titleBox {
  max-width: 800px;
  text-align: center;
  margin: 0 auto 40px
}

.titleBox p:last-of-type {
  margin-bottom: 0
}

.titleBox p {
  margin-bottom: 10px;
  color: #98a2a4;
  line-height: 1.2
}
.allBenefits {
  display: flex;
  justify-content: space-between
}
.ie .theBenefit {
  flex: 0 0 20%
}
.home .promoDiv .theBenefit {
  flex: 0 0 24%;
  padding: 10px 20px
}

.ie .home .promoDiv .theBenefit {
  flex: 0 0 21%
}
.theBenefit {
  flex: 0 0 23%;
  border: 1px solid;
  padding: 25px;
  transition: all .1s ease-in-out
}
.theBenefit .hover {
  display: none
}

.theBenefit h3 {
  margin-top: 20px;
  margin-bottom: 8px;
  font-size: 1.5rem;
  transition: all .1s ease-in-out;
  color: #666;
}

.theBenefit p {
  margin-bottom: 0;
  font-size: 1rem;
  transition: all .1s ease-in-out
}

.theBenefit img {
  max-height: 60px
}

.theBenefit:hover {
  background-color: #fff
}
.theBenefit:hover img.hover {
  display: inline-block;
}

.theBenefit:hover img.noHover {
  display: none;
}

.theBenefit:hover p {
  color: #535353;
}

.theBenefit:hover h3 {
  color: #000;
}
.whyDuct {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#why-ductless{
  margin-bottom:40px;
}

.whyDuct>div {
  flex: 0 0 49%;
  margin: 0 15px 0;
}
.benefitsDiv{
  margin: 0 15px 0;
}

.ductContent h2 {
  font-size: 2.2rem;
  font-weight: 600;
  margin-bottom: 28px
}

.ductContent p {
  color: #98a2a4;
  margin-bottom: 16px;
  font-size: 1rem
}
.ie .ductImg {
  justify-content: space-around
}

.ie .ductImg>div {
  flex: 0 0 32%
}

.ductImg img {
  width: 100%
}
.ductImg {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly
}
.ductImg>div {
  flex: 0 0 40%;
  display: flex;
  align-items: center;
  padding: 40px;
  border: 2px solid #f2f2f2;
  box-shadow: 0 3px 7px 0 rgba(0, 0, 0, .15);
  margin-bottom: 20px;
  justify-content: center
}
.qualitiesAbout {
  margin-top: 40px
}
.allQualities {
  display: flex;
  text-align: center;
  margin-bottom: 40px
}
body .allQualities, body .allBenefits, body .solutionsSingleFlex {
  flex-wrap: wrap
}
.theQuality {
  flex: 0 0 20%
}
.theQuality i {
  height: 90px;
  width: 90px;
  line-height: 90px;
  background-color: #f7f8fa;
  border-radius: 50%;
  color: #70c000;
  border: 1px solid #f1f1f1;
  margin-bottom: 20px;
  font-size: 35px
}
.theQuality h3 {
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: 600
}

.theQuality p {
  font-size: 1rem;
  line-height: 1.4;
  color: #98a2a4
}

.lineQualities::before {
  position: absolute;
  content: "";
  width: 200%;
  height: 1px;
  background-color: #f1f1f1;
  left: -50%;
  top: 35px
}

.lineQualities:last-of-type {
  display: none
}
.lineQualities {
  flex: 1 1 auto;
  position: relative
}
.productFlex {
  display: flex;
  max-width: 1000px;
  margin: 0 auto;
  justify-content: space-between
}
.eachP a:hover, .eachP a:focus {
  color: #fff;
  opacity: .7
}
.eachP {
  flex: 0 0 48%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 30px
}
.eachP h3 {
  text-align: center;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1.8rem;
  margin-bottom: 30px
}

.eachPrice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #fafafa;
  padding: 10px 0;
  flex-wrap: wrap
}
.eachP a {
  text-decoration: none;
  color: #fff;
  background-color: #70c000;
  display: block;
  text-align: center;
  padding: 20px;
  font-size: 1rem;
  text-transform: uppercase;
  font-weight: 600
}

.eachP a i {
  margin-right: 3px
}

.eachPrice>div {
  font-size: 0.9rem
}
.innerP {
  padding: 0 30px
}
.productImg img {
  vertical-align: middle;
  max-height: 65px
}

.productImg {
  text-align: center;
  margin: 40px 0 20px
}
.pricesPro {
  margin-bottom: 40px
}
.eachPrice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #fafafa;
  padding: 10px 0;
  flex-wrap: wrap
}
.leftPrice {
  flex: 1 1 auto;
  font-weight: 600;
  color: #5d5d66;
}
.leftPrice i {
  color: #70c000;
  margin-right: 5px
}
.rightPrice {
  flex: 0 0 31%;
  font-weight: 100;
  color: #5d5d66;
  text-align:end;
}






@media only screen and (max-width:400px) {
  .eachPrice>div {
    flex: 1 1 100% !important
  }
  .eachPrice>div {
    flex: 1 1 100% !important
  }
}





@media print {
  .site-inner {
    padding-top: 0;
    position: relative;
    top: -100px
  }
  .content, .content-sidebar {
    width: 100%
  }

}




@media only screen and (max-width:1340px) {
  .wrap {
    max-width: 1140px
  }
}






@media only screen and (max-width:1200px) {
  .wrap {
    max-width: 960px
  }
}






@media only screen and (max-width:1023px) {
  .wrap {
    max-width: 800px
  }
  .content, .content-sidebar-sidebar .content, .content-sidebar-sidebar .content-sidebar-wrap, .genesis-responsive-menu .genesis-nav-menu .sub-menu, .genesis-responsive-menu .genesis-nav-menu .sub-menu a, .sidebar-content-sidebar .content, .sidebar-content-sidebar .content-sidebar-wrap, .sidebar-primary, .sidebar-secondary, .sidebar-sidebar-content .content, .sidebar-sidebar-content .content-sidebar-wrap, .site-header .widget-area, .title-area {
    width: 100%
  }
  .modelsFlex>div {
    flex: 0 0 48%
  }
  .allBenefits {
    flex-wrap: wrap
  }
  .theBenefit, .ie .theBenefit {
    flex: 0 0 49%;
    margin-bottom: 10px
  }
  .whyDuct>div {
    flex: 1 1 100%
  }

  .whyDuct {
    flex-wrap: wrap
  }
  .ductContent {
    order: 2
  }

}






@media only screen and (max-width:860px) {
  .jumpMenu .wrap, .productFlex {
    flex-wrap: wrap
  }
  .wrap {
    padding-left: 5%;
    padding-right: 5%
  }

  .jumpMenu .wrap a {
    flex: 1 1 100%
  }
  .modelsFlex>div {
    flex: 1 1 100%;
  }
  body .allQualities, body .allBenefits, body .solutionsSingleFlex {
    flex-wrap: wrap;
  }
  .allBenefits .theBenefit {
    padding: 10px 10px !important;
  }
  .theBenefit {
    margin-bottom: 10px
  }
  .theQuality, .theBenefit, .singleImage, .singleContent, .home .singleImage, .home .singleContent, .ie .theBenefit {
    flex: 1 1 100%;
  }
  .lineQualities {
    display: none;
  }
  .eachP {
    flex: 1 1 100%;
  }
}

  
  `;